import { marketApi } from '@/api/marketApi';
import { isUndefinedOrNullOrEmpty, isEmpty } from '@/common/mixin/common';
import tool from '@/common/js/tool';

// function sortMarketList(marketList) {
//   let tempMarketList = {};
//   for (let item of marketList) {
//     if (!tempMarketList[item.marketCoin]) {
//       tempMarketList[item.marketCoin] = [];
//     }
//     item.pair = item.coin + '/' + item.marketCoin;
//     tempMarketList[item.marketCoin].push(item);
//   }
//   return tempMarketList;
// }

function convertDecimal(value, decimal) {
  return tool.convertToLocaleString(tool.decimalRetain(parseFloat(value), decimal), decimal);
}

function alterMarketListByCurrency(currentCurrency, sortedMarketList, currentMarket) {
  let currentMarketBar = {};
  if (!isUndefinedOrNullOrEmpty(currentCurrency)) {
    for (let key in sortedMarketList) {
      for (let item of sortedMarketList[key]) {
        item.usd = !item.usd
          ? null
          : currentCurrency.symbol + convertDecimal(item.usd * currentCurrency.rate, item.priceDec).toString();
        item.high = !item.high ? null : convertDecimal(item.high, item.priceDec);
        item.low = !item.low ? null : convertDecimal(item.low, item.priceDec);
        item.open = !item.open ? null : convertDecimal(item.open, item.priceDec);
        item.close = !item.close ? null : convertDecimal(item.close, item.priceDec);
        item.volume = !item.volume ? null : convertDecimal(item.volume, item.volDec);
        item.amount = !item.amount ? null : convertDecimal(item.amount, item.priceDec);
        // item.change = (!item.change ? null : convertDecimal(item.change, 2));
        item.change = !item.change ? null : parseFloat(item.change).toFixed(2);

        if (currentMarket && currentMarket.symbol === item.symbol) {
          currentMarketBar = item;
        }
      }
    }
    return { sortedMarketList, currentMarketBar };
  }
  return [];
}

function updateSortedMarketList(sortedMarketList, sortedMarketListByCurrency, currentCurrency, data, currentMarket) {
  data.pair = data.coin + '/' + data.marketCoin;
  // convert to currently selected currency
  let dataByCur = Object.assign({}, data);

  dataByCur.usd = !dataByCur.usd
    ? null
    : currentCurrency.symbol + convertDecimal(dataByCur.usd * currentCurrency.rate, dataByCur.priceDec).toString();
  dataByCur.high = !dataByCur.high ? null : convertDecimal(dataByCur.high, dataByCur.priceDec);
  dataByCur.low = !dataByCur.low ? null : convertDecimal(dataByCur.low, dataByCur.priceDec);
  dataByCur.open = !dataByCur.open ? null : convertDecimal(dataByCur.open, dataByCur.priceDec);
  dataByCur.close = !dataByCur.close ? null : convertDecimal(dataByCur.close, dataByCur.priceDec);
  dataByCur.volume = !dataByCur.volume ? null : convertDecimal(dataByCur.volume, dataByCur.volDec);
  dataByCur.amount = !dataByCur.amount ? null : convertDecimal(dataByCur.amount, dataByCur.priceDec);
  // dataByCur.change = (!dataByCur.change ? null : convertDecimal(dataByCur.change, 2));
  dataByCur.change = !dataByCur.change ? null : parseFloat(dataByCur.change).toFixed(2);

  let currentMarketBar = {};
  if (currentMarket && currentMarket.symbol === data.symbol) {
    currentMarketBar = Object.assign({}, dataByCur);
  }

  if (sortedMarketList[data.marketCoin]) {
    for (let index in sortedMarketList[data.marketCoin]) {
      if (sortedMarketList[data.marketCoin][index].symbol === data.symbol) {
        sortedMarketList[data.marketCoin][index] = data;
        sortedMarketListByCurrency[data.marketCoin][index] = dataByCur;
        return { sortedMarketList, sortedMarketListByCurrency, currentMarketBar };
      }
    }
    sortedMarketList[data.marketCoin].push(data);
    sortedMarketListByCurrency[data.marketCoin].push(dataByCur);
    return { sortedMarketList, sortedMarketListByCurrency, currentMarketBar };
  } else {
    sortedMarketList[data.marketCoin] = [];
    sortedMarketList[data.marketCoin].push(data);

    sortedMarketListByCurrency[data.marketCoin] = [];
    sortedMarketListByCurrency[data.marketCoin].push(dataByCur);
    return { sortedMarketList, sortedMarketListByCurrency, currentMarketBar };
  }
}

function updateMarketList(marketList, data) {
  if (marketList.length > 0) {
    for (let item of marketList) {
      if (item.symbol === data.symbol) {
        item = data;
        return marketList;
      }
    }
  }
  marketList.push(data);
  return marketList;
}

function exUpdateMarketList(currentCurrency, sortedMarketList, sortedMarketListByCurrency, data, currentMarket) {
  data.pair = data.coin + '/' + data.marketCoin;
  let matchedKey = '';
  let matchedIndex = -1;

  for (let key in sortedMarketList) {
    for (let index in sortedMarketList[key]) {
      // Filter out current market, let kline websocket to update in order to achieve consistency in UI
      if (sortedMarketList[key][index].symbol === data.symbol && data.symbol !== currentMarket.symbol) {
        sortedMarketList[key][index] = data;
        matchedKey = key;
        matchedIndex = index;
      }
    }
  }

  if (matchedIndex !== -1) {
    if (currentCurrency.abbreviation !== 'USD') {
      data.usd = parseFloat(data.usd) * currentCurrency.rate;
      data.high = parseFloat(data.high) * currentCurrency.rate;
      data.open = parseFloat(data.open) * currentCurrency.rate;
      data.low = parseFloat(data.low) * currentCurrency.rate;
      data.amount = parseFloat(data.amount) * currentCurrency.rate;
    }

    sortedMarketListByCurrency[matchedKey][matchedIndex] = data;
  }

  return { sortedMarketList, sortedMarketListByCurrency };
}

function alterMarketHotListByCurrency(currentCurrency, marketHotList) {
  if (!isUndefinedOrNullOrEmpty(currentCurrency)) {
    for (let item of marketHotList) {
      item.usd = !item.usd
        ? null
        : currentCurrency.symbol + convertDecimal(item.usd * currentCurrency.rate, item.priceDec).toString();
      item.high = !item.high ? null : convertDecimal(item.high, item.priceDec);
      item.low = !item.low ? null : convertDecimal(item.low, item.priceDec);
      item.open = !item.open ? null : convertDecimal(item.open, item.priceDec);
      item.close = !item.close ? null : convertDecimal(item.close, item.priceDec);
      item.volume = !item.close ? null : convertDecimal(item.volume, item.volDec);
      item.amount = !item.amount ? null : convertDecimal(item.amount, item.priceDec);
      // item.change = (!item.change ? null : convertDecimal(item.change, 2));
      item.change = !item.change ? null : parseFloat(item.change).toFixed(2);
    }
    return marketHotList;
  }
  return [];
}

function updateMarketHotList(marketHotList, marketHotListByCurrency, currentCurrency, data, fromSocket) {
  data.pair = data.coin + '/' + data.marketCoin;
  // convert to currently selected currency
  let dataByCur = Object.assign({}, data);
  dataByCur.usd = !dataByCur.usd
    ? null
    : currentCurrency.symbol + convertDecimal(dataByCur.usd * currentCurrency.rate, dataByCur.priceDec).toString();
  dataByCur.high = !dataByCur.high ? null : convertDecimal(dataByCur.high, dataByCur.priceDec);
  dataByCur.low = !dataByCur.low ? null : convertDecimal(dataByCur.low, dataByCur.priceDec);
  dataByCur.open = !dataByCur.open ? null : convertDecimal(dataByCur.open, dataByCur.priceDec);
  dataByCur.close = !dataByCur.close ? null : convertDecimal(dataByCur.close, dataByCur.priceDec);
  dataByCur.volume = !dataByCur.volume ? null : convertDecimal(dataByCur.volume, dataByCur.volDec);
  dataByCur.amount = !dataByCur.amount ? null : convertDecimal(dataByCur.amount, dataByCur.priceDec);
  // dataByCur.change = (!dataByCur.change ? null : convertDecimal(dataByCur.change, 2));
  dataByCur.change = !dataByCur.change ? null : parseFloat(dataByCur.change).toFixed(2);

  if (marketHotList && marketHotList.length > 0) {
    for (let index in marketHotList) {
      // if symbol matched, update the data. Assuming this data will come from socket as API only called once.
      if (marketHotList[index].symbol === data.symbol) {
        marketHotList[index] = data;
        marketHotListByCurrency[index] = dataByCur;
        return { marketHotList, marketHotListByCurrency };
      }
    }
  }
  if (!fromSocket) {
    // For data from socket, only update market hot list if the pair matched. Else hot list will contain all market pairs
    // This section is for data insertion to hot list on first load.
    marketHotList.push(data);
    marketHotListByCurrency.push(dataByCur);
  }
  return { marketHotList, marketHotListByCurrency };
}

function updateMarketBar(currentCurrency, currentMarketBar, sortedMarketList) {
  const coin = currentMarketBar.coin;
  const marketCoin = currentMarketBar.marketCoin;
  for (let item of sortedMarketList[marketCoin]) {
    if (coin === item.coin) {
      currentMarketBar.usd = !item.usd ? null : currentCurrency.symbol + convertDecimal(item.usd * currentCurrency.rate, item.priceDec).toString();
    }
  }
  return currentMarketBar;
}

const market = {
  state: {
    marketGroup: [],
    marketList: [],
    sortedMarketList: {},
    sortedMarketListByCurrency: {},
    marketHotList: [],
    marketHotListByCurrency: [],
    marketPair: [],
    currentMarketBar: {},
  },
  getters: {
    getMarketGroup: state => state.marketGroup,
    getMarketList: state => state.marketList,
    getSortedMarketList: state => state.sortedMarketList,
    getSortedMarketListByCurrency: state => state.sortedMarketListByCurrency,
    getMarketHotList: state => state.marketHotList,
    getMarketHotListByCurrency: state => state.marketHotListByCurrency,
    getMarketPair: state => state.marketPair,
    getCurrentMarketBar: state => state.currentMarketBar,
  },
  mutations: {
    SET_MARKET_GROUP(state, marketGroup) {
      state.marketGroup = marketGroup;
    },
    SET_MARKET_LIST(state, marketList) {
      state.marketList = marketList;
    },
    SET_SORTED_MARKET_LIST(state, sortedMarketList) {
      state.sortedMarketList = sortedMarketList;
    },
    SET_SORTED_MARKET_LIST_BY_CURRENCY(state, sortedMarketListByCurrency) {
      state.sortedMarketListByCurrency = sortedMarketListByCurrency;
    },
    SET_MARKET_HOT_LIST(state, marketHotList) {
      state.marketHotList = marketHotList;
    },
    SET_MARKET_HOT_LIST_BY_CURRENCY(state, marketHotListByCurrency) {
      state.marketHotListByCurrency = marketHotListByCurrency;
    },
    SET_MARKET_PAIR(state, marketPair) {
      state.marketPair = marketPair;
    },
    SET_CURRENT_MARKET_BAR(state, currentMarketBar) {
      state.currentMarketBar = currentMarketBar;
    },
  },
  actions: {
    getMarketGroup_action({ commit }) {
      return marketApi.getMarketGroup().then(response => {
        if (response) {
          commit('SET_MARKET_GROUP', response.data);
          return response.data;
        }
        return [];
      });
    },
    updateMarketList_action({ commit, getters, state }, data) {
      const marketList = JSON.parse(JSON.stringify(state.marketList));
      const sortedMarketList = JSON.parse(JSON.stringify(state.sortedMarketList));
      const sortedMarketListByCurrency = JSON.parse(JSON.stringify(state.sortedMarketListByCurrency));
      const marketListResult = updateMarketList(marketList, data);
      commit('SET_MARKET_LIST', marketListResult);
      const result = updateSortedMarketList(
        sortedMarketList,
        sortedMarketListByCurrency,
        getters.Getter_Current_Currency,
        data,
        getters.Getter_Current_Market
      );
      commit('SET_SORTED_MARKET_LIST', result.sortedMarketList);
      commit('SET_SORTED_MARKET_LIST_BY_CURRENCY', result.sortedMarketListByCurrency);
      if (!isEmpty(result.currentMarketBar)) {
        commit('SET_CURRENT_MARKET_BAR', result.currentMarketBar);
      }
      return true;
    },
    getMarketList_action({ commit, dispatch }) {
      return marketApi.getMarketList().then(async response => {
        if (response && response.data.length > 0) {
          for (let item of response.data) {
            await dispatch('updateMarketList_action', item);
          }
          return response;
        }
        return response;
      });
    },
    alterMarketListByCurrency_action({ commit, getters, state }) {
      const sortedMarketList = JSON.parse(JSON.stringify(state.sortedMarketList));
      const sortedMarketListByCurrency = alterMarketListByCurrency(getters.Getter_Current_Currency, sortedMarketList);
      commit('SET_SORTED_MARKET_LIST_BY_CURRENCY', sortedMarketListByCurrency.sortedMarketList);
      return sortedMarketListByCurrency; // completed
    },
    updateCurrentMarketBar_action({ commit, getters, state }) {
      const currentMarketBar = JSON.parse(JSON.stringify(state.currentMarketBar));
      const sortedMarketList = JSON.parse(JSON.stringify(state.sortedMarketList));
      const updatedMarketBar = updateMarketBar(getters.Getter_Current_Currency, currentMarketBar, sortedMarketList);
      commit('SET_CURRENT_MARKET_BAR', updatedMarketBar);
    },
    exUpdateMarketList_action({ commit, getters, state }, data) {
      // Used only in exchange page, will ignore current market pair and let kline websocket to update in order to achieve consistency in UI
      const sortedMarketList = JSON.parse(JSON.stringify(state.sortedMarketList));
      const sortedMarketListByCurrency = JSON.parse(JSON.stringify(state.sortedMarketListByCurrency));
      const result = exUpdateMarketList(
        getters.Getter_Current_Currency,
        sortedMarketList,
        sortedMarketListByCurrency,
        data,
        getters.Getter_Current_Market
      );
      if (!isUndefinedOrNullOrEmpty(result)) {
        commit('SET_SORTED_MARKET_LIST', result.sortedMarketList);
        commit('SET_SORTED_MARKET_LIST_BY_CURRENCY', result.sortedMarketListByCurrency);
      }
    },
    getMarketHotList_action({ commit, dispatch }) {
      return marketApi.getMarketHotList().then(async response => {
        if (response && response.data.length > 0) {
          for (let item of response.data) {
            let param = {
              value: item,
              fromSocket: false,
            };
            await dispatch('updateMarketHotList_action', param);
          }
          return true;
        }
        return response;
      });
    },
    updateMarketHotList_action({ commit, getters, state }, data) {
      let fromSocket = false;
      if (data.fromSocket !== null && data.fromSocket !== undefined) {
        fromSocket = data.fromSocket;
      }

      const marketHotList = JSON.parse(JSON.stringify(state.marketHotList));
      const marketHotListByCurrency = JSON.parse(JSON.stringify(state.marketHotListByCurrency));

      const result = updateMarketHotList(
        marketHotList,
        marketHotListByCurrency,
        getters.Getter_Current_Currency,
        data.value,
        fromSocket
      );
      commit('SET_MARKET_HOT_LIST', result.marketHotList);
      commit('SET_MARKET_HOT_LIST_BY_CURRENCY', result.marketHotListByCurrency);
      return true;
    },
    alterMarketHotListByCurrency_action({ commit, getters, state }) {
      const marketHotList = JSON.parse(JSON.stringify(state.marketHotList));
      const marketHotListByCurrency = alterMarketHotListByCurrency(getters.Getter_Current_Currency, marketHotList);
      commit('SET_MARKET_HOT_LIST_BY_CURRENCY', marketHotListByCurrency);
      return true;
    },
    getMarketPair_action({ commit }) {
      return marketApi.getMarketPair().then(response => {
        if (response) {
          const data = response.data.reduce(
            (prevVal, curVal) => {
              prevVal[curVal.symbol] = {
                priceDec: curVal.priceDec,
                volDec: curVal.volDec,
                coin: curVal.coin,
                marketCoin: curVal.marketCoin,
              };
              return prevVal;
            },
            {} /* By putting {}, the value of prevVal in the first loop will be {} */
          );
          commit('SET_MARKET_PAIR', data);
          return response.data;
        }
        return [];
      });
    },
  },
};

export default market;
